(function () {
  if (window.__tinyImgLinkPreloaderLoaded) {
    return;
  }
  window.__tinyImgLinkPreloaderLoaded = true;

  var urlToPreload;
  var mouseoverTimer;
  var lastTouchTimestamp;

  var prefetcher = document.createElement("link");
  var isSupported =
    prefetcher.relList &&
    prefetcher.relList.supports &&
    prefetcher.relList.supports("prefetch");
  var isDataSaverEnabled =
    navigator.connection && navigator.connection.saveData;
  var allowQueryString = "instantAllowQueryString" in document.body.dataset;
  var allowExternalLinks =
    "instantAllowExternalLinks" in document.body.dataset;

  if (!(isSupported && !isDataSaverEnabled)) {
    return;
  }

  prefetcher.rel = "prefetch";
  document.head.appendChild(prefetcher);

  var listenerOptions = { capture: true, passive: true };
  document.addEventListener("touchstart", touchstartListener, listenerOptions);
  document.addEventListener("mouseover", mouseoverListener, listenerOptions);

  function touchstartListener(event) {
    lastTouchTimestamp = performance.now();
    var anchor = event.target.closest("a");
    if (!isPreloadable(anchor)) {
      return;
    }

    anchor.addEventListener("touchcancel", touchendAndTouchcancelListener, {
      passive: true,
    });
    anchor.addEventListener("touchend", touchendAndTouchcancelListener, {
      passive: true,
    });
    urlToPreload = anchor.href;
    preload(anchor.href);
  }

  function touchendAndTouchcancelListener() {
    urlToPreload = undefined;
    stopPreloading();
  }

  function mouseoverListener(event) {
    if (performance.now() - (lastTouchTimestamp || 0) < 1100) {
      return;
    }

    var anchor = event.target.closest("a");
    if (!isPreloadable(anchor)) {
      return;
    }

    anchor.addEventListener("mouseout", mouseoutListener, { passive: true });
    urlToPreload = anchor.href;
    mouseoverTimer = setTimeout(function () {
      preload(anchor.href);
      mouseoverTimer = undefined;
    }, 65);
  }

  function mouseoutListener(event) {
    if (event.relatedTarget) {
      var current = event.target.closest("a");
      var related = event.relatedTarget.closest
        ? event.relatedTarget.closest("a")
        : null;

      if (current && related && current === related) {
        return;
      }
    }

    if (mouseoverTimer) {
      clearTimeout(mouseoverTimer);
      mouseoverTimer = undefined;
      return;
    }

    urlToPreload = undefined;
    stopPreloading();
  }

  function isPreloadable(anchor) {
    if (!anchor || !anchor.href) return false;
    if (urlToPreload === anchor.href) return false;

    var url = new URL(anchor.href);

    var allowExternal =
      allowExternalLinks ||
      url.origin === location.origin ||
      anchor.dataset.instant !== undefined;
    if (!allowExternal) return false;

    if (!["http:", "https:"].includes(url.protocol)) return false;
    if (url.protocol === "http:" && location.protocol === "https:") return false;

    var allowSearch =
      allowQueryString ||
      !url.search ||
      anchor.dataset.instant !== undefined;
    if (!allowSearch) return false;

    var samePathAndSearch =
      url.hash &&
      url.pathname + url.search === location.pathname + location.search;
    if (samePathAndSearch) return false;

    if (anchor.dataset.noInstant !== undefined) return false;

    return true;
  }

  function preload(href) {
    prefetcher.href = href;
  }

  function stopPreloading() {
    prefetcher.removeAttribute("href");
  }
})();
